export interface Email {
  RFM: string;
  STR: string;
}

export interface Country {
  Country: string;
  Emails: Email[];
}

export const CountryEmailMapping: Country[] = [
  {
    Country: 'DE',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'AT',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'BE',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'CZ',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'ES',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'FI',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'FR',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'HU',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'IE',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'IT',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'NL',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'NO',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'PL',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'PT',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'RU',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'SE',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'SK',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'TR',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
  {
    Country: 'UK',
    Emails: [
      { RFM: 'JH-RFM-DE@jungheinrich.de', STR: 'JH-STR-DE@jungheinrich.de' },
    ],
  },
];
